import script from "./AdminPageDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPageDescription.vue?vue&type=script&setup=true&lang=js"

import "./AdminPageDescription.vue?vue&type=style&index=0&id=351fe892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351fe892"]])

export default __exports__